import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PurchaseOperationResponseDto } from '@domain/purchase-operation/dtos/purchase-operation.response.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOperationUnreconciledService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('purchase/operation/unreconciled');
  }

  show(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/show/${request.refId}`;
    return this.http.get<ApiResponse<PurchaseOperationResponseDto>>(queryUrl);
  }

  reconcile(request: { operationRefId: string; transactionRefId?: string }) {
    const queryUrl = `${this.getApiUrl()}/reconcile`;
    return this.http.post<ApiResponse<{ message: string }>>(queryUrl, request);
  }
}
